export default __webpack_public_path__ + "locales/ja-JP/SingleSignOn.json?hash=29b980be6440a79d7ee45f4fefe8a98f";